import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { faqItems } from "@/mocks/home";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full border-b border-background-200 bg-secondary-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-16 md:px-8 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="inline-flex items-center gap-2 rounded-full border border-secondary-300 bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                <span className="inline-flex h-1.5 w-4 rounded-full bg-secondary-500" />
                常见问题
              </span>
              <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl lg:text-[2.1rem]">
                关于黑料一区，先把这几个问题讲明白
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
                从更新频率到核实标准，从投稿方式到更正流程，你关心的都在这里。没找到答案，可以在话题讨论里直接提问。
              </p>
            </Reveal>

            <Reveal delay={100}>
              <div className="mt-8 rounded-lg border border-secondary-300 bg-background-50 p-5">
                <div className="flex items-center gap-2">
                  <i className="ri-question-answer-line text-xl text-primary-600" />
                  <h3 className="font-heading text-base font-bold text-foreground-950">
                    还有别的疑问？
                  </h3>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  去社区讨论区发帖，编辑会挑高频问题补进这份清单。涉及个人隐私的内容我们不会回应，也不会收录。
                </p>
                <a
                  href="#talk"
                  className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-chat-3-line" />
                  去讨论区提问
                </a>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div className="flex flex-col gap-3">
              {faqItems.map((item, index) => {
                const open = openIndex === index;
                return (
                  <Reveal key={item.q} delay={index * 50}>
                    <div
                      className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                        open ? "border-primary-300" : "border-background-200"
                      }`}
                    >
                      <button
                        type="button"
                        onClick={() => setOpenIndex(open ? -1 : index)}
                        className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                      >
                        <span className="text-sm font-bold leading-snug text-foreground-950 md:text-base">
                          {item.q}
                        </span>
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                            open ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                          }`}
                        >
                          <i className={open ? "ri-subtract-line" : "ri-add-line"} />
                        </span>
                      </button>
                      <div
                        className={`grid transition-all duration-300 ease-out ${
                          open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                        }`}
                      >
                        <div className="overflow-hidden">
                          <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                            {item.a}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}